import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { BsDropdownConfig } from "ngx-bootstrap/dropdown";
import { GROUP_STATUS_CONST } from "../../constants";
import { EfficacyCriteria } from "../../store/students/state";
import { ClickableBarComponent } from "../clickable-bar/clickable-bar.component";

@Component({
  selector: "student-comp-table-head",
  templateUrl: "./student-comp-table-head.component.html",
  styleUrls: ["./student-comp-table-head.component.scss"],
  providers: [{ provide: BsDropdownConfig, useValue: { autoClose: false } }],
})
export class StudentCompTableHeadComponent implements OnInit {
  @Input() panels;
  @Input() columns;
  @Input() districtMetrics;
  @Input() schoolOverall;
  @Input() school;
  @Input() sortsAndFilters;
  @Input() groupCriteria: Array<EfficacyCriteria>;
  @Input() groupStatusSort: string;
  @Input() groupStatusFilters: Array<string>;
  @Output() sortsFiltersSelected = new EventEmitter();

  @ViewChildren(ClickableBarComponent)
  clickableBarChildren: QueryList<ClickableBarComponent>;

  status = { openDropdown: null };
  selectedFilterItem;
  selectedSort;
  min;
  max;
  singleVal;
  statusFilters;
  groupStatusColumnDef: string = `Status shows whether a student in the group meets or does not meet group criteria. 
  A student not in the group, but who does meet group criteria, will show up as “recommended”.`;
  noFilterObj = { text: "- No Filter -", id: 1 };
  betweenObj = { text: "Between", id: 2 };
  greaterThanObj = { text: "Greater than or equal to", id: 3 };
  lessThanObj = { text: "Less than or equal to", id: 4 };
  equalToObj = { text: "Equal to", id: 5 };
  filterItems = [
    this.betweenObj,
    this.greaterThanObj,
    this.lessThanObj,
    this.equalToObj,
  ];
  GROUP_STATUS_CONSTANT;

  constructor() {}

  ngOnInit() {
    this.GROUP_STATUS_CONSTANT = GROUP_STATUS_CONST;
  }

  toggleDropdown(id) {
    if (this.status.openDropdown == id) {
      this.status.openDropdown = null;
    } else {
      this.status.openDropdown = id;
    }
  }

  filter(event) {
    this.selectedFilterItem = event;
  }

  sort(event) {
    this.selectedSort = event;
  }

  cancel() {
    this.selectedFilterItem = { text: "- No Filter -", id: 1 };
    this.selectedSort = null;
    this.status.openDropdown = null;
  }

  submit(column, quickFilter) {
    this.sortsFiltersSelected.emit({
      kpi: column,
      sort: this.selectedSort,
      filter: this.selectedFilterItem,
      groupStatusFilters: this.statusFilters,
      min: this.min,
      max: this.max,
      singleVal: this.singleVal,
    });
    // If we selected a new filter via the dropdown clear the bar selection
    if (this.selectedFilterItem != null && !quickFilter) {
      let tmpBar = this.clickableBarChildren.find((item) => {
        return item.column["id"] == column["id"];
      });
      if (tmpBar) {
        tmpBar.selectedSeg = null;
      }
    }
    this.selectedSort = null;
    this.selectedFilterItem = null;
    this.status.openDropdown = null;
  }

  minChange(event) {
    this.min = event;
  }

  maxChange(event) {
    this.max = event;
  }

  singleValChange(event) {
    this.singleVal = event;
  }

  groupStatusFilterChange(event: Array<string>) {
    this.statusFilters = event;
  }

  segmentEvent(event) {
    if (event["data"] != null) {
      let adjustment = 0;
      // Set adjustment to make PL max exclusive. For integers, adjustment = 1
      // For roundTo = 1 adjustment = 0.1
      // For roundTo = 2 adjustment = 0.01
      if (event["column"]["roundTo"] > 0) {
        adjustment = 1 / 10 ** event["column"]["roundTo"];
      } else {
        adjustment = 1;
      }
      // when upIsGood=true, the rightmost bar will be greater than or equal to
      // the leftmost bar will be less than or equal to
      // UNLESS it's a plain equals

      // when upIsGood=false, the leftmost bar will be greater than or equal to
      // the rightmost bar will be less than or equal to
      // UNLESS it's a plain equals

      // for all other bars, it's a between
      // UNLESS it's a plain equals
      if (
        event["data"]["performanceLevelMax"] - adjustment ==
        event["data"]["performanceLevelMin"]
      ) {
        this.barEqualsCase(event);
      } else {
        if (event.pseudoUpIsGood) {
          if (event.data.order == event.numBars) {
            this.barGreaterThanCase(event);
          } else if (event.data.order == 1) {
            this.barLessThanCase(event, adjustment);
          } else {
            this.barBetweenCase(event, adjustment);
          }
        } else {
          if (event.data.order == event.numBars) {
            this.barLessThanCase(event, adjustment);
          } else if (event.data.order == 1) {
            this.barGreaterThanCase(event);
          } else {
            this.barBetweenCase(event, adjustment);
          }
        }
      }
      this.sort("DESC");
      this.submit(event["column"], true);
    } else {
      this.cancel();
      this.sort("CLEAR");
      this.maxChange(null);
      this.minChange(null);
      this.submit(event["column"], true);
    }
  }

  barEqualsCase(event) {
    this.maxChange(null);
    this.minChange(null);
    this.singleValChange(event["data"]["performanceLevelMin"]);
    this.filter(this.equalToObj);
  }

  barGreaterThanCase(event) {
    this.maxChange(null);
    this.minChange(null);
    this.singleValChange(event["data"]["performanceLevelMin"]);
    this.filter(this.greaterThanObj);
  }

  barLessThanCase(event, adjustment) {
    this.maxChange(null);
    this.minChange(null);
    this.singleValChange(event["data"]["performanceLevelMax"] - adjustment);
    this.filter(this.lessThanObj);
  }

  barBetweenCase(event, adjustment) {
    this.maxChange(event["data"]["performanceLevelMax"] - adjustment);
    this.minChange(event["data"]["performanceLevelMin"]);
    this.singleValChange(null);
    this.filter(this.betweenObj);
  }
}
